import {
  type Faro,
  initializeFaro,
  SessionInstrumentation,
} from '@grafana/faro-web-sdk';

let faro: Faro | undefined;

const getFaro = (): Faro => {
  if (!faro) {
    faro = initializeFaro({
      url: 'https://faro-collector-prod-eu-west-0.grafana.net/collect/3f5f41c81b12503225798d233cb6d42e',
      app: {
        name: 'orodha-observability',
        version: '1.0.0',
        environment: process.env.NEXT_PUBLIC_INTERNAL_ENVIRONMENT,
      },
      // disable all default tools
      instrumentations: [new SessionInstrumentation()],
    });
  }

  return faro;
};

export { getFaro };
